import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Contest } from '../../global';
import styles from './PageNavigation.module.scss';
import { useAuth } from '../../context/AuthContext';
import { ROUTEPATHS } from '../../routes/routePaths';
import { contestNavPages } from '../../mockdata/navPages';
import { computeContestPhase } from '../../helpers/contestUtilities';

interface Props {
  contest: Contest;
  pageName?: string;
}
export const ContestPageNavigation: React.FC<Props> = ({ contest, pageName = 'Brief' }) => {
  const navigationRef = useRef<any>(null);
  const { loggedUser, showLoginPopup } = useAuth();
  const [visible, setVisible] = useState(false);

  const callbackFunction = () => {
    const scroll = window.scrollY;
    if (scroll > 170) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const isDisabled = (navLink: any) => {
    if (navLink.text === 'Gallery') {
      if (contest.hideGalleryTab) {
        return true;
      }
      if (!loggedUser){
        return false;
      }
      if (loggedUser?.userType === 'G') {
        return false;
      }
      if (loggedUser?.userType === 'C' && loggedUser?.username === contest?.username) {
        return false;
      }
      return contest.isPrivate || contest.hideGalleryTab;
    } else if (navLink.text === 'Upload') {
      if (!loggedUser) {
        return false;
      }

      if (contest.needsAccessCode) {
        return true;
      }
      if (contest.needsNDA) {
        return true;
      }
      if (loggedUser && (loggedUser.userType === 'C' || loggedUser.userType === 'G')) {
        return true;
      }
      return computeContestPhase(contest) !== 'upload-phase';
    } else if (navLink.text === 'Awards') {
      if (!loggedUser) {
        return false;
      }
      return contest.hideAwardsTab;
    } else if (navLink.text === 'Inspirations') {
      if (!loggedUser) {
        return false;
      }
      if (contest.needsAccessCode) {
        return true;
      }
      if (contest.needsNDA) {
        return true;
      }

      return contest.hideInspirationTab;
    }
    return false;
  };

  window.addEventListener('scroll', callbackFunction);
  return (
    <div className={`${styles.navigationWrapperBrief} container-fluid px-0 ${!visible ? '' : styles.fixed}`} ref={navigationRef} style={{ backgroundColor: '#E3E3E3' }}>
      <div className="container-md">
        <div className="row">
          <div className={`col-12 d-flex flex-nowrap ${styles.tabsWrapperBrief}`}>
            {contestNavPages.map((navLink, index) => (
              <Link
                onClick={(e) => {
                  console.log('Clicked on nav link:', navLink.text);
                  if (!loggedUser) {
                    showLoginPopup();
                    e.preventDefault();
                  }
                }}
                key={'pageLink_' + index}
                className={`text color-dark flex-grow-1 flex-shrink-0 text-center ${styles.pageTabBrief} 
                ${navLink.path === '/' + pageName && styles.activeTabBrief}
                ${isDisabled(navLink) && styles.disabledLinks}`}
                to={`/${ROUTEPATHS.CONTEST}/${contest?.nameForURL}${navLink.path}`}
              >
                <span className="text-16">{navLink.text}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
